module.exports = __webpack_public_path__ + "img/vink.2c956c99.svg";